import {SpavaObj} from './SpavaObj'

class ParkingLot extends SpavaObj {
  name

  constructor (o) {
    super(o)
    o = o || {}
    this.name = o.name || ''
  }
}

class Controller extends SpavaObj {
  name
  parkingLot

  constructor (o) {
    super(o)
    o = o || {}
    this.name = o.name || ''
    this.parkingLot = new ParkingLot(o.parkingLot)
    this.inOrOut = o.inOrOut
    this.gateInfo = o.gateInfo||{}
  }

  get parkingLotId () {
    return this.parkingLot && this.parkingLot.id
  }

  get parkingLotName () {
    return this.parkingLot && this.parkingLot.name
  }
}

export {ParkingLot, Controller}
